/*
    vu-drag directive - for drag and drop within a simple list

    vu-drag="list" :drag-options="{enable, removeOnSpill, moveable}"
 */
import dragula from 'dragula'

let arrays = []
let drakes = []

export default function (vapp) {
    vapp.directive('drag', {
        beforeMount(container, binding, vnode) {
            let options = vnode.props?.drag
            if (!options || !(options.move || options.remove)) return
            let items = binding.value || []                 // Array of items to manage
            let dragIndex                                   // Index of dragged element
            let arrayIndex

            let drake = dragula([container], options)
                .on('drag', (el, source) => {
                    // When we drag an item, memorize its index.
                    dragIndex = findDomIndex(source, el) - options.padding
                })
                .on('drop', (el, target) => {
                    let targetIndex = findDomIndex(target, el) - options.padding
                    items = arrays[arrayIndex]
                    move(items, dragIndex, targetIndex)
                    let ev = new CustomEvent('drag', {
                        detail: {type: 'drop', index: dragIndex, targetIndex, dir: options.dir},
                    })
                    target.dispatchEvent(ev)
                    return true
                })
                .on('remove', (el, target) => {
                    items = arrays[arrayIndex]
                    let item = items.splice(dragIndex, 1)[0]
                    let ev = new CustomEvent('drag', {
                        detail: {type: 'remove', index: dragIndex, dir: options.dir, item},
                    })
                    target.dispatchEvent(ev)
                    return true
                })
            arrayIndex = addDrake(items, drake)
        },

        updated(elm, binding) {
            if (binding.value && binding.oldValue) {
                swapArray(binding.oldValue, binding.value)
            }
        },

        unmounted(container, binding) {
            let drake = getDrake(binding.value)
            if (drake) {
                drake.destroy()
            }
        }
    })
}

/*
   Find the index of a DOM element within a given container.
 */
function findDomIndex(container, el) {
    return Array.prototype.indexOf.call(container.children, el)
}

/*
   Move an array item from one index to another. The given array is transformed, not returned.
 */
function move(array, fromIndex, toIndex) {
    array.splice(toIndex, 0, array.splice(fromIndex, 1)[0])
}

/*
   Register a drake instance based on the reference of the given array.
 */
function addDrake(array, drake) {
    if (arrays.indexOf(array) >= 0) {
        return
    }
    arrays.push(array)
    drakes.push(drake)
    return arrays.length - 1
}

/*
   Retrieve a drake instance based on the reference of the given array.
 */
function getDrake(array) {
    let drakeIndex = arrays.indexOf(array)
    if (drakeIndex >= 0) {
        return drakes[drakeIndex]
    }
}

function swapArray(oldArray, newArray) {
    let index = arrays.indexOf(oldArray)
    if (index >= 0) {
        arrays[index] = newArray
    }
}
